import { createSlice } from "@reduxjs/toolkit";
import { AccountTypeDescription } from "../../types/types";

const initialState = {
  openModal: false,
  action: "FORM" as "FORM" | "CONFIRMATION" | "SUCCESS",
  formData: {
    bankAccountIdentification: "",
    currency: "1",
    cuit: "",
    accountType: "" as AccountTypeDescription | "",
    nickName: "",
    isCCL: false,
    isSingleBank: true,
    singleBank: "",
    singleBankNumber: "",
    singleBankSwift: "",
    singleBankABA: "",
    singleBankReference: "",
    intermediaryBank: "",
    intermediaryBankSwift: "",
    intermediaryBankABA: "",
    intermediaryBankReference: "",
    observation: "",
  },
};

const accountContactSlice = createSlice({
  name: "accountContact",
  initialState,
  reducers: {
    updateFormData: (state, action) => {
      state.formData = {
        ...state.formData,
        ...action.payload,
      };
    },
    updateAction: (state, action) => {
      state.action = action.payload;
    },
    resetForm: (state) => {
      state.formData = initialState.formData;
      state.action = "FORM";
    },
    openModal: (state) => {
      state.openModal = true;
    },
    closeModal: (state) => {
      state.openModal = false;
      state.formData = initialState.formData;
      state.action = "FORM";
    },
  },
});

export const {
  updateFormData,
  resetForm,
  openModal,
  closeModal,
  updateAction,
} = accountContactSlice.actions;
export default accountContactSlice.reducer;
